import type {
  HTMLAttributes,
} from 'react';

import classNames from 'classnames';
import styles from './Skeleton.module.css';

type SkeletonProps = HTMLAttributes<HTMLDivElement> & {
  kind?: 'default' | 'clear';
  roundness?: 'default' | 'round' | 'rounded' | 'inherit';
}

const Skeleton = (props: SkeletonProps) => {
  const {
    kind = 'default',
    roundness = 'default',
    className,
    ...rest
  } = props;

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const skeletonClassName = classNames({
    [styles.skeleton]: true,
    [styles.clear]: kind === 'clear',
    [styles.round]: roundness === 'round',
    [styles.rounded]: roundness === 'rounded',
    [className]: !!className,
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <div
      {...rest}
      className={skeletonClassName}
    />
  );
};

export default Skeleton;
export type { SkeletonProps };
